// 地面站设置
export default {
    language: 'Language',
    company: 'Measurement Unit',
    metricSystem: 'Metric System(m/s)',
    britishSystem: 'British System(mph)',
    trajectory: 'Flight Trajectory',
    trajectoryShow: 'Show',
    trajectoryHide: 'Hide',
    mapCenter: 'Map Center',
    lng: 'Lng',
    lat: 'Lat',
    baseStationSettings: 'Base station settings',
    cloudBasedStation: 'Cloud based station',
    mobileBasedStation: 'Mobile base station',
    messageSettings: 'Message Settings',
    AP: 'Abnormal Prompt',
    SP: 'System Push',
    basicSettings: 'Basic Settings',
    DID: 'Default information display',
    BSD: 'Base station display',
    NFZD: 'No fly zone display',
    WDV: 'Waypoint default value',
    WH: 'Height',
    WS: 'Speed',
    WR: 'Radius',
    HT: 'Hover Time',
    HM: 'Waypoint Mode',
    circlingDirection: 'Circling Direction',
    clockwise: 'Clockwise',
    counterclockwise: 'Counterclockwise',
    PTDV: 'Pointing the default value',
    waitingTime: 'Waiting Time',
    circlingRadius: 'Circling Radius',
    cycles: 'Cycles',
    tip_PELng: 'Please enter longitude',
    tip_PELat: 'Please enter latitude',
    tip_PEAI: 'Please enter an integer',
    tip_IAL: '0 is always loop',
    tip_ETNO: 'Enter the number of cycles incorrectly',
}